<mat-toolbar style="float: left;clear: none;display: -webkit-box;padding-top: 5px">
  <button mat-icon-button (click)="toggleMenu()" style="float: left;clear: none">
    <mat-icon style="font-size:24px">menu</mat-icon>
  </button>
 <div class="mcrit_title" style="float: left;clear: none">{{ 'authzone.titolApp' | translate }}</div>

 <div style="float:left;clear:none;width:35%" *ngIf="router.url !== '/quefaig'">&nbsp;</div>
 <div class="botonera" *ngIf="router.url == '/quefaig'">
    <button matTooltip="{{ 'authzone.entrada' | translate }}" attr.aria-label="{{ 'authzone.entrada' | translate }}" (click)="entrada()" style="width:90px;height:35px;background-color: #1159A9;color:white;font-size: 0.6em;font-weight: bold;float:left;clear: left;cursor:pointer;margin-left:30px;margin-bottom: 10px;border: none;border-bottom: 1px solid white">{{ 'authzone.entrada' | translate }}<h5 style="margin-bottom:0px;font-size:0.65em;margin:-5px" *ngIf="tokenStorage.regisE">{{tokenStorage.regisE}}</h5><h5 style="margin-bottom:0px" *ngIf="!tokenStorage.regisE">&nbsp;</h5>
    </button>
    <button matTooltip="{{ 'authzone.sortida' | translate }}" attr.aria-label="{{ 'authzone.sortida' | translate }}" style="width:90px;height:35px;padding-left:0px;background-color: #1159A9;color:white;font-size: 0.6em;font-weight: bold;float:left;clear: none;cursor:pointer;margin-left:30px;margin-bottom: 10px;border: none;border-bottom: 1px solid white" (click)="sortida()">{{ 'authzone.sortida' | translate }}<h5 style="margin-bottom:0px;font-size:0.65em;margin:-5px" *ngIf="tokenStorage.regisS">{{tokenStorage.regisS}}</h5><h5 style="margin-bottom:0px" *ngIf="!tokenStorage.regisS">&nbsp;</h5>
    </button>
    <mat-checkbox style="padding-left: 20px;font-size:0.55em;float:left;clear: none" name="follow" [ngModel]="teletreball" (ngModelChange)="teletre()">{{ 'authzone.teletreball' | translate }}</mat-checkbox>
 </div>

 <button mat-icon-button
   matTooltip="{{ 'authzone.switchLangToolTip' | translate }}"
   attr.aria-label="{{ 'authzone.switchLangToolTip' | translate }}"
   matTooltipClass="tooltip-style"
   [matMenuTriggerFor]="langMenu">
   <mat-icon color="secondary" style="font-size:24px;float:right;padding-top:5px;margin-right:30px;clear:none">translate</mat-icon>
 </button>

 <mat-menu #langMenu="matMenu">
   <button mat-menu-item *ngFor="let lang of languageService.availableLangs"
     (click)="setLang(lang)"
     [class.mat-menu-item-highlighted]="lang === translate.currentLang">
     {{ languageService.langLabels[lang] || lang }}
   </button>
 </mat-menu>

 <div class="mcrit_title" title="{{ 'authzone.usuariRegistrat' | translate:{ name: userInfo.name } }}"><h4>{{userInfo.name}}</h4></div>
 <div class="suggeriments" title="{{ 'authzone.ticketingTooltip' | translate }}" attr.placeholder="{{ 'authzone.ticketingTooltip' | translate }}">
    <a href="./#/ticketing" target="_blank">
       <mat-icon style="color: white;font-size: 24px;">receipt_long</mat-icon>
    </a>
 </div>
 <div class="suggeriments" style="float:right;clear:none;text-align:right;width:5%;position:relative;padding-top:5px" title="{{ 'authzone.mcritTooltip' | translate }}">
   <a href="https://www.mcrit.com" target="_blank" style="color:white;text-decoration:none;cursor:pointer">
     <img src="./assets/M-crit.png" style="width:50px;height:40px" alt="{{ 'authzone.mcritTooltip' | translate }}">
   </a>
 </div>

</mat-toolbar>
<mat-sidenav-container style="">
  <mat-sidenav #mainMenu mode="side">
    <mcrit-gestio-authzone-side-menu></mcrit-gestio-authzone-side-menu>
  </mat-sidenav>
  <div class="router-container">
    <router-outlet></router-outlet>
  </div>
</mat-sidenav-container>
